module.exports = __webpack_public_path__ + "static/media/urn.2aff93ae.jpg";